// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivitiesSelector_activities__cn\\+mM {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: var(--space-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg);
  box-shadow: var(--shadow-xs);
  color: var(--text-primary);
  box-sizing: border-box;
}

.ActivitiesSelector_activities__cn\\+mM h2 {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

/* Toolbar */
.ActivitiesSelector_activities__toolbar__4tsvu {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.ActivitiesSelector_activities__search__CDLuQ {
  flex: 1 1;
  min-width: 220px;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ActivitiesSelector_activities__search__CDLuQ::placeholder {
  color: var(--text-placeholder);
}

.ActivitiesSelector_activities__search__CDLuQ:focus,
.ActivitiesSelector_activities__search__CDLuQ:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.ActivitiesSelector_activities__sets__8Ukt8 {
  width: 54px;
  padding: 4px;
  text-align: center;
}

.ActivitiesSelector_activities__bulk__xoPKb {
  display: flex;
  gap: var(--space-2);
}

.ActivitiesSelector_btn__gx8-h {
  min-height: 34px;
  padding: 6px 14px;
  border: 1px solid var(--primary);
  border-radius: var(--radius-input);
  background: var(--primary);
  color: var(--text-on-primary);
  font-family: var(--font);
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition:
    background-color var(--dur-fast) var(--ease-standard),
    color var(--dur-fast) var(--ease-standard);
}

.ActivitiesSelector_btn__gx8-h:hover {
  background: var(--primary-light);
  border-color: var(--primary-light);
}

.ActivitiesSelector_btn--secondary__uH2Va {
  background: transparent;
  color: var(--primary);
}

.ActivitiesSelector_btn--secondary__uH2Va:hover {
  background: var(--surface-brand-wash);
  border-color: var(--primary);
  color: var(--primary-dark);
}

/* Groups */
.ActivitiesSelector_activities__groups__eKoJW {
  display: grid;
  gap: var(--space-4);
}

.ActivitiesSelector_activities__group__5zV3j {
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg);
}

.ActivitiesSelector_activities__groupHeader__w0R-r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 0.9375rem;
  font-weight: 700;
  cursor: pointer;
}

.ActivitiesSelector_activities__collapseIcon__XDCrQ {
  margin-right: var(--space-1);
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

/* Activity row */
.ActivitiesSelector_activities__list__8NSGb {
  list-style: none;
  margin: 0;
  padding: 0 var(--space-4);
}

.ActivitiesSelector_activities__item__PG3Qv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) 0;
}

.ActivitiesSelector_activities__item__PG3Qv + .ActivitiesSelector_activities__item__PG3Qv {
  border-top: 1px solid var(--border-light);
}

.ActivitiesSelector_activities__label__rIA7F {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex: 1 1;
  min-width: 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  cursor: pointer;
}

.ActivitiesSelector_activities__label__rIA7F input {
  accent-color: var(--primary);
  flex: none;
}

.ActivitiesSelector_activities__name__UajNJ {
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ActivitiesSelector_activities__repsWrapper__RNoLn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-1);
  flex: none;
  min-width: 120px;
}

.ActivitiesSelector_activities__reps__Nc92f {
  width: 58px;
  padding: 5px 6px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-sm);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.875rem;
  text-align: center;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ActivitiesSelector_activities__reps__Nc92f:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.ActivitiesSelector_activities__repsLabel__Xqhm9 {
  width: 44px;
  flex: none;
  text-align: right;
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

/* Save state */
.ActivitiesSelector_activities__savestate__\\+GJzB {
  text-align: right;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.ActivitiesSelector_activities__savestate--saving__03HfB {
  color: var(--primary);
}

.ActivitiesSelector_activities__savestate--saved__\\+9XWC {
  color: #2e7d32;
}

.ActivitiesSelector_activities__savestate--error__b0KvZ {
  color: var(--error);
}

/* States */
.ActivitiesSelector_activities__loading__RSfcS,
.ActivitiesSelector_activities__error__\\+lzrY {
  padding: var(--space-5);
  font-size: 0.9375rem;
  line-height: 1.55;
  color: var(--text-secondary);
}

.ActivitiesSelector_activities__error__\\+lzrY {
  border-radius: var(--radius-sm);
  background: var(--surface-error);
  color: #b71c1c;
  font-weight: 600;
}

@media (max-width: 600px) {
  .ActivitiesSelector_activities__cn\\+mM {
    padding: var(--space-4);
  }

  .ActivitiesSelector_activities__search__CDLuQ {
    min-width: 0;
  }

  .ActivitiesSelector_activities__item__PG3Qv {
    flex-wrap: wrap;
  }

  .ActivitiesSelector_activities__repsWrapper__RNoLn {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/ActivitiesSelector.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;;8CAE4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB;;mDAEiD;AACnD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;;EAEE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".activities {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n  width: 100%;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: var(--space-6);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  box-shadow: var(--shadow-xs);\n  color: var(--text-primary);\n  box-sizing: border-box;\n}\n\n.activities h2 {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n/* Toolbar */\n.activities__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n}\n\n.activities__search {\n  flex: 1;\n  min-width: 220px;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.activities__search::placeholder {\n  color: var(--text-placeholder);\n}\n\n.activities__search:focus,\n.activities__search:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.activities__sets {\n  width: 54px;\n  padding: 4px;\n  text-align: center;\n}\n\n.activities__bulk {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.btn {\n  min-height: 34px;\n  padding: 6px 14px;\n  border: 1px solid var(--primary);\n  border-radius: var(--radius-input);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-family: var(--font);\n  font-size: 0.875rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition:\n    background-color var(--dur-fast) var(--ease-standard),\n    color var(--dur-fast) var(--ease-standard);\n}\n\n.btn:hover {\n  background: var(--primary-light);\n  border-color: var(--primary-light);\n}\n\n.btn--secondary {\n  background: transparent;\n  color: var(--primary);\n}\n\n.btn--secondary:hover {\n  background: var(--surface-brand-wash);\n  border-color: var(--primary);\n  color: var(--primary-dark);\n}\n\n/* Groups */\n.activities__groups {\n  display: grid;\n  gap: var(--space-4);\n}\n\n.activities__group {\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg);\n}\n\n.activities__groupHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-3) var(--space-4);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.activities__collapseIcon {\n  margin-right: var(--space-1);\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n/* Activity row */\n.activities__list {\n  list-style: none;\n  margin: 0;\n  padding: 0 var(--space-4);\n}\n\n.activities__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-3) 0;\n}\n\n.activities__item + .activities__item {\n  border-top: 1px solid var(--border-light);\n}\n\n.activities__label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  flex: 1;\n  min-width: 0;\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  cursor: pointer;\n}\n\n.activities__label input {\n  accent-color: var(--primary);\n  flex: none;\n}\n\n.activities__name {\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.activities__repsWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--space-1);\n  flex: none;\n  min-width: 120px;\n}\n\n.activities__reps {\n  width: 58px;\n  padding: 5px 6px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-sm);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.875rem;\n  text-align: center;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.activities__reps:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.activities__repsLabel {\n  width: 44px;\n  flex: none;\n  text-align: right;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n/* Save state */\n.activities__savestate {\n  text-align: right;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.activities__savestate--saving {\n  color: var(--primary);\n}\n\n.activities__savestate--saved {\n  color: #2e7d32;\n}\n\n.activities__savestate--error {\n  color: var(--error);\n}\n\n/* States */\n.activities__loading,\n.activities__error {\n  padding: var(--space-5);\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.activities__error {\n  border-radius: var(--radius-sm);\n  background: var(--surface-error);\n  color: #b71c1c;\n  font-weight: 600;\n}\n\n@media (max-width: 600px) {\n  .activities {\n    padding: var(--space-4);\n  }\n\n  .activities__search {\n    min-width: 0;\n  }\n\n  .activities__item {\n    flex-wrap: wrap;\n  }\n\n  .activities__repsWrapper {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activities": `ActivitiesSelector_activities__cn+mM`,
	"activities__toolbar": `ActivitiesSelector_activities__toolbar__4tsvu`,
	"activities__search": `ActivitiesSelector_activities__search__CDLuQ`,
	"activities__sets": `ActivitiesSelector_activities__sets__8Ukt8`,
	"activities__bulk": `ActivitiesSelector_activities__bulk__xoPKb`,
	"btn": `ActivitiesSelector_btn__gx8-h`,
	"btn--secondary": `ActivitiesSelector_btn--secondary__uH2Va`,
	"activities__groups": `ActivitiesSelector_activities__groups__eKoJW`,
	"activities__group": `ActivitiesSelector_activities__group__5zV3j`,
	"activities__groupHeader": `ActivitiesSelector_activities__groupHeader__w0R-r`,
	"activities__collapseIcon": `ActivitiesSelector_activities__collapseIcon__XDCrQ`,
	"activities__list": `ActivitiesSelector_activities__list__8NSGb`,
	"activities__item": `ActivitiesSelector_activities__item__PG3Qv`,
	"activities__label": `ActivitiesSelector_activities__label__rIA7F`,
	"activities__name": `ActivitiesSelector_activities__name__UajNJ`,
	"activities__repsWrapper": `ActivitiesSelector_activities__repsWrapper__RNoLn`,
	"activities__reps": `ActivitiesSelector_activities__reps__Nc92f`,
	"activities__repsLabel": `ActivitiesSelector_activities__repsLabel__Xqhm9`,
	"activities__savestate": `ActivitiesSelector_activities__savestate__+GJzB`,
	"activities__savestate--saving": `ActivitiesSelector_activities__savestate--saving__03HfB`,
	"activities__savestate--saved": `ActivitiesSelector_activities__savestate--saved__+9XWC`,
	"activities__savestate--error": `ActivitiesSelector_activities__savestate--error__b0KvZ`,
	"activities__loading": `ActivitiesSelector_activities__loading__RSfcS`,
	"activities__error": `ActivitiesSelector_activities__error__+lzrY`
};
export default ___CSS_LOADER_EXPORT___;
